module.exports = __webpack_public_path__ + "assets/img/fz-1.44ebcc62.jpg";